module.exports = __webpack_public_path__ + "img/2010 winteressen 031.61c1529c.jpg";